export const gradeToNumberMap = {
  '4a': 4.0, '4a+': 4.2, '4b': 4.4, '4b+': 4.6, '4c': 4.8, '4c+': 5.0,
  '5a': 5.2, '5a+': 5.4, '5b': 5.6, '5b+': 5.8, '5c': 6.0, '5c+': 6.2,
  '6a': 6.4, '6a+': 6.6, '6b': 6.8, '6b+': 7.0, '6c': 7.2, '6c+': 7.4,
  '7a': 7.6, '7a+': 7.8, '7b': 8.0, '7b+': 8.2, '7c': 8.4, '7c+': 8.6,
  '8a': 8.8, '8a+': 9.0, '8b': 9.2, '8b+': 9.4, '8c': 9.6, '8c+': 9.8,
  '9a': 10.0,
};

export const GRADE_ENUM = Object.keys(gradeToNumberMap);

export function convertGradeToNumber(gradeString) {
  if (!gradeString) return null;
  return gradeToNumberMap[gradeString.toString().toLowerCase().trim()] ?? null;
}
